import cn from 'classnames';
import { FC } from 'react';
import './styles.scss';

interface GameLoaderProps {
    className: string;
}

export const GameLoader: FC<GameLoaderProps> = ({className}) => {

  return (
      <div className={cn('cs_loader', className)}>
        <div className={cn('cs_loader_inner', 'slow')}>
          <label>●</label>
          <label>●</label>
          <label>●</label>
          <label>●</label>
          <label>●</label>
          <label>●</label>
        </div>
      </div>
  );
};
